import { Dispatch, ReactElement, SetStateAction, createContext, useState } from 'react';
import { MinimalTarget } from '@/generated/model';
import { TargetAttributesTabValue } from '@/types';

export type TargetAttributesContextType = {
  tab: TargetAttributesTabValue;
  setTab: Dispatch<SetStateAction<TargetAttributesTabValue>>;
  selectedTargets: MinimalTarget[];
  setSelectedTargets: Dispatch<SetStateAction<MinimalTarget[]>>;
  searchText: string | undefined;
  setSearchText: Dispatch<SetStateAction<string | undefined>>;
  maxTargetNumber: number;
  setMaxTargetNumber: Dispatch<SetStateAction<number>>;
  unsavedChanges: boolean;
  setUnsavedChanges: Dispatch<SetStateAction<boolean>>;
  drawerOpen: boolean;
  setDrawerOpen: Dispatch<SetStateAction<boolean>>;
};

export const ctxTargetAttributes = createContext<TargetAttributesContextType | undefined>(undefined);

export function TargetAttributesContext({ children }: { children: ReactElement }) {
  const [tab, setTab] = useState<TargetAttributesTabValue>(TargetAttributesTabValue.entitySelect);
  const [selectedTargets, setSelectedTargets] = useState<MinimalTarget[]>([]);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [maxTargetNumber, setMaxTargetNumber] = useState<number>(0);
  const [unsavedChanges, setUnsavedChanges] = useState<boolean>(false);
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);

  return (
    <ctxTargetAttributes.Provider
      value={{
        tab,
        setTab,
        selectedTargets,
        setSelectedTargets,
        searchText,
        setSearchText,
        maxTargetNumber,
        setMaxTargetNumber,
        unsavedChanges,
        setUnsavedChanges,
        drawerOpen,
        setDrawerOpen,
      }}
    >
      {children}
    </ctxTargetAttributes.Provider>
  );
}
